<template>
	<div>
		<el-dialog v-model="dialogTableVisible" top="18vh" class="chat_dialog" style="background-color:#fff" width="60%" :close-on-click-modal='false' :close-on-press-escape='false'>
			<template #header>
				<el-row>
				</el-row>
			</template>
			<el-row class="chat">
				<el-col :span="6" class="right_border" style="margin-top: -32px;padding-top:10px">
					<el-row class="left">
						<el-col :span="24" class="input freeze">
							<el-input v-model="freeze" placeholder="搜索联系人或型号" @keyup.enter.native="onSubmit">
								<template #prefix>
									<img src="../../assets/img/logo.png" alt="" width="40px">
								</template>
							</el-input>
						</el-col>
						<el-col :span="24" class="list">
							<div ref="ccc">
								<el-scrollbar class="" height="65vh" @scroll="handleScroll" ref="left_scrollbarRef">
									<el-row class="cell" @click="pitch_click(item)" v-bind:class="{'pitch': pitch_id==item.id }" v-for="(item,index) in data">
										<RightClickMenu :items="menuItems" @item-click="handleItemClick(item.id,index)">
											<el-row>
											<el-col :span="5" class="" v-if="!item.cc_user_img">
												<el-avatar :size="45" @click="showViewer (require('../../assets/img/user.png'))" :src="require('../../assets/img/user.png')" />
												<el-badge :value="item.num?item.num:''" class="item" style="top: -51px;"><!-- item.num?item.num:'' -->
															</el-badge>
											</el-col>
											<el-col :span="5" class="" v-else>
												<el-avatar :size="45" @click="showViewer (this.$axios.defaults.baseURL+item.cc_user_img)" :src="this.$axios.defaults.baseURL+item.cc_user_img" />
												<el-badge :value="item.num?item.num:''" class="item"  style="top: -51px;"><!--  -->
															</el-badge>
											</el-col>
											<el-col :span="19" class="">
												<el-col :span="24" class="name">
													<el-row>
														<el-col :span="18" class="name_overflow">
															<span>{{item.user_name}} </span>
														</el-col>
														<el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" class="name_overflow " style="">
															<span class="last_time">{{last_time(item.last_time)}} </span>
														</el-col>
													</el-row>
												</el-col>
												<el-col :span="24">
													<el-row>
														<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="name_overflow">
															<span style="font-size: 12px;color:rgb(132, 126, 124);">{{item.chat_msg}} </span>
														</el-col>
														
													</el-row>
												</el-col>
											</el-col></el-row>
										</RightClickMenu>
									</el-row>
								</el-scrollbar>
							</div>
						</el-col>
					</el-row>
				</el-col>
				<!--  -->
				<el-col :span="18" class="right">
					<el-row>
						<el-col :span="24">
							<el-row style="border-bottom: 1px solid var(--el-border-color);margin-top: -32px;padding-top:10px;padding-bottom: 10px;">
								<el-col :span="17">
									<div class="title">
										<span class="name">
											{{pitch_data.user_name}}
										</span>
										<span class="name" style="margin-left:10px;font-size:14px" v-if="pitch_data.mobile">
											{{pitch_data.mobile}}
										</span>
									</div>
								</el-col>
								<el-col :span="5">
									<div class="title">
										<el-button size="small" class="sendoneMessage" @click="sendoneMessage" style="color:#fff" color="#E99D42">交换联系方式</el-button>
									</div>
								</el-col>
							</el-row>
							<el-row>
								<el-col :span="24" style="padding:0px 10px;background-color:rgb(244, 244, 244);height:60px">
									<el-row v-if="goods_form.id">
										<el-col :span="2" class="goods_img" style="margin-top: 5px;">
											<el-image style="" :src="img[0]" fit="fit" @click="preview">
												<template #error>
													<div style="padding: 25% 0;font-size:12px">
														暂无图片
													</div>
												</template>
											</el-image>
										</el-col>
										<el-col :span="16" style="margin-top: 7px;">
											<el-row>
												<el-col :span="24" class="" style="font-weight: 600;margin-top:2px;overflow: hidden;white-space: nowrap;">
													<span>{{ goods_form.brand_name }}</span>
													<span style="margin-left:5px"> {{ goods_form.name }}</span>
													<span style="margin-left:5px"> {{ goods_form.model }}</span>
													<span style="margin-left:5px"> {{ goods_form.order_no }}</span>
													<span style="margin-left:15px"> *{{ goods_form.num }}</span>
												</el-col>
												<el-col :span="24" class="" style="margin-top:5px">
													<div class="stock_type_txt_button">
														<span v-for="item in goods_form.stock_type_txt_list">
															<el-button class="A" size="small" text bg v-if="item=='二手' || item=='过保' || item=='包附破损'" style="">{{item}}</el-button>
															<el-button class="C" size="small" text bg v-else color="#ff8a5c">{{item}}</el-button>
														</span>
														<span style="color:red;font-weight: 600;">
															<span>￥</span><span style="">{{ goods_form.tsw_price }}</span>
														</span>
													</div>
												</el-col>
											</el-row>
										</el-col>
										<el-col :span="6">
											<el-row>
												<!-- <el-col :span="24">
												<div style="margin:0px 0px 0px 0px">
													<img src="../../assets/img/chat_goods.png" @click="preview" alt="" width="30px">
												</div>
											</el-col> -->
												<el-col :span="24" style="text-align:right">
													<div style="margin:0px 0px 0px 0px">
														<img src="../../assets/img/chat_jb.png" style="margin-top:13px" alt="" width="30px" @click="dialogTableVisible_feedback=true">
													</div>
												</el-col>
											</el-row>
										</el-col>
									</el-row>
								</el-col>
							</el-row>
						</el-col>
						<el-col :span="24" class="content" ref="content" style="background: #fff;">
							<!-- v-loading="chat_loading" -->
							<el-row>
								<!-- 循环聊天记录 -->
								<el-scrollbar height="39vh" style="width: 100%;" ref="right_scrollbarRef">
									<el-row>
										<el-col :span="24" class="">
											<div class="chat_total" style="text-align:center">
												<span v-if="chat_loading"><i class="el-icon-loading"></i>正在加载中...</span>
												<span v-if="chat_total==10 && !chat_loading">
													<el-link type="info" @click="view_more">查看更多</el-link>
												</span>
												<span v-if="chat_total<10 && !chat_loading">暂无更多</span>
											</div>
										</el-col>
									</el-row>
									<div v-for="(item,index) in chat_list">
										<!-- 帮手登录和账号登录userid是一样的判断需要加一个主账号id; -->
										<el-col :span="24" class="content_right" v-if="chat_left(item)">
											<el-row>
												<el-col :span="24" style="text-align:center">
													<span class="time">
														{{item.time}}
													</span>
													<!-- <span class="user_name">
														{{item.user_name}}
													</span>
													<span class="user_name" v-if="item.lead_id">
														（帮手）
													</span> -->
												</el-col>
												<el-col :span="24">
													<el-row>
														<el-col :span="24" style="">
															<div class="cdetails" v-if="item.state==2" style="width:10%">
																<span>{{item.content}}</span>
																<div v-if="item.state==2" style="width:100%">
																	<el-carousel height="100px" arrow="never" indicator-position="none">
																		<el-carousel-item v-for="(item1,key1) in item.inveimgs">
																			<el-image style="width: 100%;height: 100%" fit="cover" :src="item1" :preview-src-list="item.inveimgs" :initial-index="key1" :preview-teleported="true">
																				<template #error>
																					<div style="padding: 25% 0;font-size:12px">
																						暂无图片
																					</div>
																				</template>
																			</el-image>
																		</el-carousel-item>
																	</el-carousel>
																</div>
															</div>
															<div class="cdetails" v-else>
																<span>{{item.content}}</span>
															</div>
														</el-col>
														<!-- <el-col :span="1" style="">
														
															<el-avatar :size="40"  v-if="item.user_img" :src="this.$axios.defaults.baseURL+item.user_img" />
															<el-avatar :size="40" v-else :src="require('../../assets/img/user.png')" />
														</el-col> -->
													</el-row>
												</el-col>
											</el-row>
										</el-col>
										<el-col :span="24" class="content_left" v-else>
											<el-row v-if="item.link==1 || item.pic==1 || item.qty==1">
												<el-col :span="24" style="text-align:center">
													<!-- <span class="user_name">
														{{item.user_name}}
													</span>
													<span class="user_name" v-if="item.lead_id">
														（帮手）
													</span> -->
													<span class="time">
														{{item.time}}
													</span>
												</el-col>
												<el-col :span="24">
													<el-row>
														<!-- <el-col :span="1" style="">
															<el-avatar :size="40" v-if="item.user_img" :src="this.$axios.defaults.baseURL+item.user_img" />
															<el-avatar :size="40" v-else :src="require('../../assets/img/user.png')" />
														</el-col> -->
														<el-col :span="24" style="">
															<div class="cdetails" style="margin-left:20px">
																<div>
																	{{item.content}}
																</div>
																<div v-if="item.isgive==3">
																	<span style="color:red">
																		已拒绝
																	</span>
																</div>
																<div v-else-if="item.isgive==2">
																	<span style="color:#67c23a;">
																		已同意
																	</span>
																</div>
																<div v-else>
																	<el-button type="danger" link @click="exchange(item,item.chat_id,3,index)">
																		拒绝
																	</el-button>
																	<el-button type="success" link @click="exchange(item,item.chat_id,2,index)">
																		同意
																	</el-button>
																</div>
															</div>
														</el-col>
													</el-row>
												</el-col>
											</el-row>
											<el-row v-else>
												<el-col :span="24" class="user_name" style="text-align:center">
													<!-- <span>
														{{item.user_name}}
													</span>
													<span class="user_name" v-if="item.lead_id">
														（帮手）
													</span> -->
													<span class="time">
														{{item.time}}
													</span>
												</el-col>
												<el-col :span="24">
													<el-row>
														<!-- <el-col :span="1" style="">
															<el-avatar :size="40" v-if="item.user_img"  :src="this.$axios.defaults.baseURL+item.user_img" />
															<el-avatar :size="40" v-else :src="require('../../assets/img/user.png')" />
														</el-col> -->
														<el-col :span="24" style="">
															<div class="cdetails" style="width:10%;margin-left:20px" v-if="item.state==2">
																<span>{{item.content}}</span>
																<div style="width:100%">
																	<el-carousel height="100px" arrow="never" indicator-position="none">
																		<el-carousel-item v-for="(item1,key1) in item.inveimgs">
																			<el-image style="width: 100%;height: 100%" fit="cover" :src="item1" :preview-src-list="item.inveimgs" :initial-index="key1" :preview-teleported="true">
																				<template #error>
																					<div style="padding: 25% 0;font-size:12px">
																						暂无图片
																					</div>
																				</template>
																			</el-image>
																		</el-carousel-item>
																	</el-carousel>
																</div>
															</div>
															<div class="cdetails" v-else style="margin-left:20px">
																<span>{{item.content}}</span>
															</div>
														</el-col>
													</el-row>
												</el-col>
											</el-row>
										</el-col>
									</div>
								</el-scrollbar>
							</el-row>
						</el-col>
					</el-row>
					<div style="padding:1px;background: #f4f4f4;">
						<div style="border-radius: 15px;">
							<el-row style="background-color:#fff;border-radius: 0.9375rem !important;" ref="textarea_send">
								<!-- <el-col :span="24">
									<el-row>
										<el-col :span="12">
											<div style="margin:10px 0px 0px 20px">
												<img src="../../assets/img/chat_goods.png" @click="preview" alt="" width="30px">
											</div>
										</el-col>
										<el-col :span="11" style="text-align:right">
											<div style="margin:10px 0px 0px 20px">
												<img src="../../assets/img/chat_jb.png" alt="" width="30px" @click="dialogTableVisible_feedback=true">
											</div>
										</el-col>
									</el-row>
								</el-col> -->
								<el-col :span="24" class="textarea_send">
									<el-input maxlength="200" type="textarea" v-on:keydown="handleKeyCode" placeholder="请输入内容" v-model="content">
									</el-input>
									<!-- <div style="height:18vh" contenteditable="true">
								1
							</div> -->
								</el-col>
								<el-col :span="24" style="text-align:right;border-radius:  0 0 0.9375rem 0.9375rem !important;padding-top:10px;padding-bottom:10px;padding-right:10px" class="button">
									<span>
										{{content_num()}}/200
									</span>
									<el-button style="border-radius:8px;border:0px" @click="send" color="rgba(55, 97, 255, 0.3)" :loading="sendMessage_loading">
										<img src="../../assets/img/chat_fs.png" alt="" width="20px">
									</el-button>
								</el-col>
							</el-row>
						</div>
					</div>
					<!--  -->
				</el-col>
			</el-row>
			<div>
				<el-image-viewer v-if="viewerVisible" :url-list="[currentImageUrl]" @close="viewerVisible = false" />
			</div>
		</el-dialog>
		<examineImg ref="examineImg"></examineImg>
		<el-dialog v-model="dialogTableVisible_feedback" width="30%" :close-on-click-modal='false' :close-on-press-escape='false'>
			<el-row>
				<el-col :span="24" class="right_border">
					<el-row>
						<el-col :span="24" class="" ref="feedback">
							<el-form :model="goods_form" label-width="55px" style="max-width: 600px;margin-top:10px" label-position="left">
								<el-form-item label="型号">
									<template #label>
										<div class="custom-label" style="justify-content: space-between;">
											<span>型</span>
											<span>号</span>
										</div>
									</template>
									<el-input v-model="goods_form.model" disabled />
								</el-form-item>
								<el-form-item label="">
									<template #label>
										<div class="custom-label" style="justify-content: space-between;">
											<span>订</span>
											<span>货</span>
											<span>号</span>
										</div>
									</template>
									<el-input v-model="goods_form.order_no" disabled />
								</el-form-item>
								<el-form-item label="">
									<template #label>
										<div class="custom-label" style="justify-content: space-between;">
											<span>数</span>
											<span>量</span>
										</div>
									</template>
									<el-input v-model="goods_form.num" disabled />
								</el-form-item>
								<el-form-item label="">
									<template #label>
										<div class="custom-label" style="justify-content: space-between;">
											<span>反</span>
											<span>馈</span>
										</div>
									</template>
									<el-select v-model="goods_form.type" placeholder="选择" size="default">
										<el-option label="索要图片" value="2" />
										<el-option label="核实数量" value="3" />
										<el-option label="举报违规" value="1" />
									</el-select>
								</el-form-item>
								<el-form-item label="">
									<template #label>
										<div class="custom-label" style="justify-content: space-between;">
											<span>留</span>
											<span>言</span>
										</div>
									</template>
									<el-input v-model="goods_form.remark" type="textarea" class="textarea_remark" style="height:15vh" />
								</el-form-item>
								<el-form-item>
									<el-col :span="24" class="">
										<div style="text-align:right">
											<el-button type="primary" @click="feedback" :loading="feedback_loading">确认</el-button>
										</div>
									</el-col>
								</el-form-item>
							</el-form>
						</el-col>
					</el-row>
					<div>
					</div>
				</el-col>
			</el-row>
		</el-dialog>
	</div>
</template>
<script>
import '../../assets/public/chat.css' //优化表格样式
import { ElMessage, ElMessageBox } from 'element-plus'
import { Calendar, Search } from '@element-plus/icons-vue'
import examineImg from '../public/img';
import RightClickMenu from '../public/RightClickMenu';
export default {
	components: {
		examineImg,
		RightClickMenu
	},

	data() {

		return {
			dialogTableVisible_feedback: false,
			currentImageUrl: '',
			viewerVisible: false,
			WarnTriangleFilledInfo_he: '',
			middle_he: '',
			WarnTriangleFilledInfo: false,
			goods_form: {},
			img: [],
			content: '',
			pitch_id: '',
			admin_pitch_id: '', //查询的时候 后台根据这个删除没有发消息的聊天框
			pitch_data: {},
			chat_list: [],
			data: [

			],
			freeze: '',

			dialogTableVisible: false,
			feedback_loading: false,
			loading: false,
			page_size: 30,
			page: 1,
			sendMessage_loading: false,
			chat_loading: false,
			chat_page_size: 10,
			chat_page: 1,
			chat_total: 0,
			user_id: '',
			lead_id: '',
			goods: {},
			menuItems: [
				{
					label: '删除',
					handler: () => console.log('执行删除操作')
				}
			],
		}
	},
	props: [],

	updated() {

	},
	beforeUnmount() {
		// 组件卸载时取消监听
		this.$chat.off('chat-message', this.handleMessage);
	},

	mounted() {


		this.$chat.on('chat-message', this.handleMessage);
	},

	activated() {


	},
	created() {
		this.user_id = localStorage.getItem('user_id');
		this.lead_id = localStorage.getItem('lead_id');
		//this.search();
	},
	watch: {
		dialogTableVisible(val, newval) {
			//console.log(val, newval)
			if (!val) {
				this.$emit("closeChat");
			} else {
				var obj = this
				this.$nextTick(() => {
					obj.middle_he = (this.$refs.content.$el.scrollHeight + this.$refs.textarea_send.$el.scrollHeight)
					console.log()
				});
			}
		}
	},
	methods: {
		handleItemClick(id,index) {
			/*this.handleItemClick_list(id,index)
			return false*/
			ElMessageBox.confirm(
					'确认删除聊天记录？',
					'提示', {
						confirmButtonText: '确认',
						cancelButtonText: '取消',
						type: 'warning',
					}
				)
				.then(() => {
					this.handleItemClick_ajax(id,index)
				})
				.catch(() => {

				})
		},
		async	handleItemClick_ajax(id,index){
			await this.$axios.post('/api/yunsys.chat/delroom', {id}).then(async (res) => {
					this.feedback_loading = false;
					if (res.status === 200) {
						var res = res.data
						if (res.code !== 0) {
							return ElMessage({
								message: res.msg,
								type: 'error',
								grouping: true // 开启合并功能
							})
						} else {
							this.handleItemClick_list(id,index)
						}
					} else {
						this.$message.error('服务器错误');
					}
				})
				.catch(err => {
					this.$message.error('服务器错误');
				})
		},
		//删除后跟新列表
		handleItemClick_list(id,index){
			if (this.pitch_id==id) { //删除已经被选中的需要自动切换到第一个
				this.goods_form= {};
				this.img= [];
				this.pitch_id= '';
				this.pitch_data= {};
				this.chat_list= [];
				this.goods={};
				this.chat_page = 1;
				this.chat_total = 0;
				this.content = '';
				this.data.splice(index, 1);
				if (this.data.length>0) {
					this.pitch_click(this.data[index])
				}
			}else{

				this.data.splice(index, 1);
				if (this.data.length<=0) {
					this.goods_form= {};
					this.img= [];
					this.pitch_id= '';
					this.pitch_data= {};
					this.chat_list= [];
					this.goods={};
					this.chat_page = 1;
					this.chat_total = 0;
					this.content = '';
				}
			}
		},
		preview() {
			console.log(this.img)
			this.$refs['examineImg'].img_title = this.goods_form;
			this.$refs['examineImg'].data = this.img;
			this.$refs['examineImg'].dialogTableVisible = true;
			this.$refs['examineImg'].imgBigUrl = this.img[0];
		},
		content_num() {
			// 处理可能的空值情况，若为null或undefined则返回0
			if (this.content === null || this.content === undefined) {
				return 0;
			}
			// 将输入转换为字符串（防止非字符串类型传入），然后返回长度
			return String(this.content).length;
		},
		showViewer(url) {
			this.viewerVisible = true
			this.currentImageUrl = url
		},
		//判断谁是这条信息的发送人，显示在左右
		chat_left(val) {
			if ((this.lead_id + '_' + this.user_id) == (val.lead_id + '_' + val.user_id)) {
				return true;
			}
		},
		WarnTriangleFilledInfo_click() {
			this.WarnTriangleFilledInfo = !this.WarnTriangleFilledInfo
			if (!this.WarnTriangleFilledInfo) { // 举报隐藏
				this.middle_he = (this.$refs.content.$el.scrollHeight + this.$refs.textarea_send.$el.scrollHeight)
			} else { //举报显示
				this.$nextTick(() => {
					this.WarnTriangleFilledInfo_he = this.middle_he - this.$refs.feedback.$el.scrollHeight
				});

			}

		},
		last_time(time) {
			if (time) {
				if (time.includes('-')) {
					return time.substring(5)
				}
			}
			return time
			//if
		},
		feedback(info) {
			if (!this.goods_form.type) {
				return ElMessage({
					message: '请选择反馈类型！',
					type: 'error',
					grouping: true // 开启合并功能
				})
			}
			if (this.goods_form.type == 1) {
				var title = "确认举报此条商品！"
			} else if (this.goods_form.type == 2) {
				var title = "确认向卖家索要图片！"
			} else if (this.goods_form.type == 3) {
				var title = "确认向卖家核实数量！"
			}
			ElMessageBox.confirm(
					title,
					'提示', {
						confirmButtonText: '确认',
						cancelButtonText: '取消',
						type: 'warning',
					}
				)
				.then(() => {
					this.feedback_ajax()
				})
				.catch(() => {

				})
		},
		ShoppingCart(id) {
			ElMessageBox.prompt('请填写数量！', '加入购物车', {
					confirmButtonText: '确认',
					cancelButtonText: '取消',
					inputValue: '1'

				})
				.then(({ value }) => {

				})
				.catch(() => {

				})
		},
		async feedback_ajax() {
			var data = this.goods_form;
			data.backlog_id = this.pitch_data.id
			this.feedback_loading = true;
			await this.$axios.post('/api/yunsys.Chat/addreport', data).then(async (res) => {
					this.feedback_loading = false;
					if (res.status === 200) {
						var res = res.data
						if (res.code !== 0) {
							return ElMessage({
								message: res.msg,
								type: 'error',
								grouping: true // 开启合并功能
							})
						} else {
							this.dialogTableVisible_feedback = false;
							if (this.goods_form.type == 1) {
								return ElMessage({
									message: res.msg,
									type: 'success',
									grouping: true // 开启合并功能
								})
							} else {

								this.chat_list.push(res.data)
								//this.content = '';
								this.$nextTick(() => {
									this.right_scrollbar_bottom()
								})
								this.right_sort(this.pitch_id, {}, 0)
							}

						}
					} else {
						this.$message.error('服务器错误');
					}
				})
				.catch(err => {
					this.feedback_loading = false;
					this.$message.error('服务器错误');
				})
		},
		//交换联系方式 索要图片 核实数量  都写在这一个接口
		exchange(item, id, info, index) {
			if (item.link == 1) { //交换联系方式
				var msg = '确认' + (info == 3 ? '拒绝' : '同意') + '交换联系方式！'
				var url = (info == 3) ? '/api/yunsys.Chat/sendgiveMessage' : '/api/yunsys.Chat/sendyesMessage';
				var data = { id: id, content: '', backlog_id: this.pitch_data.id, isgive: info }
			} else if (item.pic == 1) {
				var msg = '确认' + (info == 3 ? '拒绝' : '同意') + '索要图片！'
				var url = (info == 3) ? '/api/yunsys.Chat/sendpicMessage' : '/api/yunsys.Chat/sendpicyesMessage';
				var data = { id: id, content: '', backlog_id: this.pitch_data.id, isgive: info }
			} else if (item.qty == 1) {
				var msg = '确认' + (info == 3 ? '拒绝' : '同意') + '核实数量'
				var url = (info == 3) ? '/api/yunsys.Chat/sendqtyMessage' : '/api/yunsys.Chat/sendqtyyesMessage';
				var data = { id: id, content: '', backlog_id: this.pitch_data.id, isgive: info }
			}
			ElMessageBox.confirm(
					msg,
					'提示', {
						confirmButtonText: '确认',
						cancelButtonText: '取消',
						type: 'warning',
					}
				)
				.then(() => {
					this.exchange_ajax(id, info, index, url, data)
				})
				.catch(() => {

				})
		},

		async exchange_ajax(id, info, index, url, data) {

			await this.$axios.post(url, data).then(async (res) => {
					if (res.status === 200) {
						var res = res.data
						if (res.code !== 0) {
							return ElMessage({
								message: res.msg,
								type: 'error',
								grouping: true // 开启合并功能
							})
						} else {
							this.chat_list[index]['isgive'] = info;
							this.chat_list.push(res.data)
							//this.content = '';
							this.$nextTick(() => {
								this.right_scrollbar_bottom()
							})
							this.right_sort(this.pitch_id, {}, 0)
						}
					} else {
						this.$message.error('服务器错误');
					}
				})
				.catch(err => {
					this.$message.error('服务器错误');
				})
		},
		async getchatnum() {
			if (!localStorage.getItem('user_id')) {
				return false
			}
			await this.$axios.post('/api/yunsys.Chat/getchatnum').then(async (res) => {
					var res = res.data;
					this.$chat.state.chatnum = res.data
				})
				.catch(err => {

				})
		},
		//接受到消息
		handleMessage(message) {
			if (message.type == 'say') {
				if (message.backlog_id == this.pitch_id) {
					this.pitch_data = message.list;
					this.chat_list.push(message);
					this.$nextTick(() => {

						this.right_scrollbar_bottom()
					})
				}
				this.right_sort(message.backlog_id, message.list, 1);
			}
		},
		//接受到消息 或者发送消息 把右侧的排到第一位
		//info 0 发送消息 1 接受消息
		//message  接受消息所属列表信息
		//
		//
		right_sort(id, list, info) {
			var state = false;
			var data = {};
			this.data.forEach(function(item, index) {
				if (item.id == id) { //右侧列表存在
					state = index;
					data = item;
				}
			})
			if (info === 0) {
				if (state === false) {

				} else {
					data.num = 0;
					this.data.splice(state, 1); // 先移除该元素
					this.data.unshift(data); // 再添加到数组开头
					this.$nextTick(() => {
						this.right_scrollbar_top()
					})
				}
			} else {
				if (state === false) {
					this.data.unshift(list); // 再添加到数组开头
				} else {
					//推送的已经被打开 未读为0 并且请求接口 自动滚动到头部
					//
					//
					if (list.id == this.pitch_id) {
						list.num = 0;
					}

					this.data.splice(state, 1); // 先移除该元素
					this.data.unshift(list); // 再添加到数组开头
					if (list.id == this.pitch_id) {
						this.$nextTick(() => {
							this.right_scrollbar_top()
						})
						this.getone(this.pitch_id);
					}

				}
			}
			this.data = JSON.parse(JSON.stringify(this.data))
		},
		sendoneMessage() {
			ElMessageBox.confirm(
					'确认交换联系方式！',
					'提示', {
						confirmButtonText: '确认',
						cancelButtonText: '取消',
						type: 'warning',
					}
				)
				.then(() => {
					this.sendoneMessage_ajax()
				})
				.catch(() => {

				})
		},
		async sendoneMessage_ajax() {

			var data = { content: '', backlog_id: this.pitch_data.id, link: 1 }
			await this.$axios.post('/api/yunsys.Chat/sendoneMessage', data).then(async (res) => {
					if (res.status === 200) {
						var res = res.data
						if (res.code !== 0) {
							return ElMessage({
								message: res.msg,
								type: 'error',
								grouping: true // 开启合并功能
							})
						} else {
							this.chat_list.push(res.data)
							//this.content = '';
							this.$nextTick(() => {
								this.right_scrollbar_bottom()
							})
							this.right_sort(this.pitch_id, {}, 0)
						}
					} else {
						this.$message.error('服务器错误');
					}
				})
				.catch(err => {
					this.$message.error('服务器错误');
				})
		},
		async getone(backlog_id) {
			await this.$axios.post('/api/yunsys.Chat/getone', { backlog_id }).then(async (res) => {
					var res = res.data;
					this.getchatnum()
				})
				.catch(err => {

				})
		},
		pitch_click(data) {
			/*if (this.chat_loading) {
				return false;
			}*/
			data.num = 0;
			this.pitch_id = data.id;
			this.pitch_data = data;
			this.chat_page = 1;
			this.chat_total = 0;
			this.content = '';
			this.getonepic(this.pitch_id)
			this.getContext()
		},
		view_more() {
			this.chat_page = this.chat_page + 1;
			this.chat_total = 0;
			this.getContext()
		},
		async getContext() {
			if (this.chat_page == 1) {
				this.chat_list = [];
			}
			this.chat_loading = true
			var search = { page: this.chat_page, ps: this.chat_page_size, backlog_id: this.pitch_id }
			await this.$axios.post('/api/yunsys.Chat/getContext', search).then(async (res) => {
					var res = res.data;
					this.chat_loading = false
					if (res.code !== 0) {
						return ElMessage({
							message: res.msg,
							type: 'error',
							grouping: true // 开启合并功能
						})
					}
					var obj = this;
					if (search.backlog_id == this.pitch_id) { //防止快速切换
						res.data.data.forEach(item => {
							obj.chat_list.unshift(item)
						})
						this.chat_total = res.data.data.length;
						if (this.chat_page == 1) {
							this.$nextTick(() => {
								this.right_scrollbar_bottom()
							})
						} else {

						}
						this.getchatnum()
					}

				})
				.catch(err => {
					this.chat_loading = false
					return ElMessage({
						message: '系统错误',
						type: 'error',
						grouping: true // 开启合并功能

					})
				})
		},
		handleScroll() {
			const scrollbar = this.$refs.left_scrollbarRef
			const wrap = scrollbar.$el.querySelector('.el-scrollbar__wrap')

			if (wrap) {
				const scrollTop = wrap.scrollTop
				const scrollHeight = wrap.scrollHeight
				const clientHeight = wrap.clientHeight


				const threshold = 50
				if (scrollHeight - (scrollTop + clientHeight) < threshold) {
					this.page = this.page + 1;
					this.search();
				}
			}
		},
		async getonepic(backlog_id) {
			await this.$axios.post('/api/yunsys.Chat/getonepic', { backlog_id }).then(async (res) => {
					var res = res.data;
					if (res.code !== 0) {
						this.img = []
						this.goods_form.id = '';
						this.goods_form.order_no = '';
						this.goods_form.model = '';
						this.goods_form.num = '';
						//this.goods_form. = res.data.model;
					}
					this.img = res.data.img
					this.goods_form.id = res.data.id;
					this.goods_form.order_no = res.data.order_no;
					this.goods_form.model = res.data.model;
					this.goods_form.num = res.data.num;
					this.goods_form.sur_num = res.data.num;
					this.goods_form.brand_name = res.data.brand_name;
					this.goods_form.name = res.data.name;
					this.goods_form.mobile = res.data.mobile;
					this.goods_form.mobile = res.data.mobile;
					this.goods_form.stock_type_txt_list = res.data.stock_type_txt.split("、");
					this.goods_form.tsw_price = this.$bn.multiply(res.data.tsw_price, 1, 2);
				})
				.catch(err => {
					this.img = []
					this.goods_form.id = '';
					this.goods_form.order_no = '';
					this.goods_form.model = '';
					this.goods_form.num = '';
				})
		},
		onSubmit() {
			this.page = 1;
			this.data = [];
			this.pitch_id = '';
			this.pitch_data = [];
			this.chat_list = [];
			this.chat_page = 1;
			this.chat_total = 0;
			this.total = 0;
			this.content = '';
			this.img = [];
			this.search()
		},
		async search() {
			if (this.loading) {
				return false;
			}
			this.loading = true
			var search = { page: this.page, ps: this.page_size, freeze: this.freeze, backlog_id: this.admin_pitch_id }
			await this.$axios.post('/api/yunsys.storage/getchatlist', search).then(async (res) => {
					var res = res.data;
					this.loading = false
					if (res.code !== 0) {
						return ElMessage({
							message: res.msg,
							type: 'error',
							grouping: true // 开启合并功能
						})
					}
					var obj = this;
					this.total = res.data.total;
					res.data.data.forEach(item => {
						if (item.id == obj.pitch_id) {
							item.num = 0
							obj.pitch_data = item;
							obj.getContext()
							obj.getonepic(obj.pitch_id)
						}
						obj.data.push(item)

					})
					if (!this.pitch_id && this.data.length) {
						this.pitch_id = this.data[0].id
						this.pitch_data = this.data[0];
						this.data[0]['num'] = 0;
						this.data = JSON.parse(JSON.stringify(this.data))
						obj.getContext()
						obj.getonepic(this.pitch_id)
					}

				})
				.catch(err => {
					this.loading = false
					return ElMessage({
						message: '系统错误',
						type: 'error',
						grouping: true // 开启合并功能

					})
				})
		},
		handleKeyCode(e) {
			if (e.keyCode == 13 && e.ctrlKey) {
				this.content += "\n";
			} else if (e.keyCode == 13) {
				this.send();
				this.content = '';
			}
		},
		send() {
			// this.$chat.send(this.content, {
			// 	type: 'text',
			// 	sender: 'user123'
			// });
			// this.content = '';
			this.sendMessage({ content: this.content, backlog_id: this.pitch_data.id })
		},
		right_scrollbar_top() {
			const scrollbar = this.$refs.left_scrollbarRef
			const wrap = scrollbar.$el.querySelector('.el-scrollbar__wrap')

			if (wrap) {
				/*const scrollTop = wrap.scrollTop
				const scrollHeight = wrap.scrollHeight
				const clientHeight = wrap.clientHeight*/
				wrap.scrollTop = 0
			}
		},
		right_scrollbar_bottom() {
			const scrollbar = this.$refs.right_scrollbarRef
			const wrap = scrollbar.$el.querySelector('.el-scrollbar__wrap')

			if (wrap) {
				/*const scrollTop = wrap.scrollTop
				const scrollHeight = wrap.scrollHeight
				const clientHeight = wrap.clientHeight*/
				wrap.scrollTop = wrap.scrollHeight
			}
		},
		async sendMessage(data) {
			this.sendMessage_loading = true;
			await this.$axios.post('/api/yunsys.Chat/sendMessage', data).then(async (res) => {
					this.sendMessage_loading = false;
					if (res.status === 200) {
						var res = res.data
						if (res.code !== 0) {
							return ElMessage({
								message: res.msg,
								type: 'error',
								grouping: true // 开启合并功能
							})
						} else {
							this.chat_list.push(res.data)
							this.content = '';
							this.$nextTick(() => {
								this.right_scrollbar_bottom()
							})
							this.right_sort(this.pitch_id, {}, 0)

							/*data.content = this.wrapToBr(data.content);
							data.id = res.data.id;
							data.chat_user = res.data.chat_user;
							data.read_num = res.data.read_num;
							this.data.push(data);
							this.$nextTick(() => {
								this.$refs.singleTable.scrollTop = this.$refs.singleTable.scrollHeight;
							})*/
						}
					} else {
						this.$message.error('服务器错误');
					}
				})
				.catch(err => {
					this.sendMessage_loading = false;
					this.$message.error('服务器错误');
				})
		},
	}
}
</script>
<style lang="less" scoped>
:deep(.textarea_send .el-textarea__inner:focus) {
	border: 0px solid #DCDFE6;
	box-shadow: 0 0 0 0px var(--el-input-border-color, var(--el-border-color)) inset;

}

:deep(.chat_dialog) {
	width: 100%;
	padding-right: 0px;
	padding-bottom: 0px;
	padding-left: 0px
}

.stock_type_txt_button .el-button {
	margin-right: 5px;
	font-size: 0.70rem !important;
	padding: 0.2525rem 0.5875rem;
}

.stock_type_txt_button .A {
	color: #ff8a5c;
	background-color: rgb(255, 240, 228) !important;
}

.stock_type_txt_button .B {
	color: red;
	background-color: rgb(255, 243, 245) !important;
}

.stock_type_txt_button .C {
	color: rgb(75, 212, 205);
	background-color: rgb(223, 255, 251) !important;
}

:deep(.el-form-item) {
	margin-bottom: .325rem;
}

:deep(.freeze .el-input__wrapper) {
	box-shadow: 0 0 0 0px var(--el-input-border-color, var(--el-border-color)) inset;
}

.custom-label {
	justify-content: space-between;
	display: flex;
	width: 100%;
}

:deep(.el-dialog__headerbtn) {

	right: 10px;
	position: absolute;
	z-index: 10;
}

:deep(.freeze .el-input__inner::placeholder) {
	font-weight: bold;
	color: #000;
	padding-left:10px
}
:deep(.freeze .el-input__inner) {
	border: 1px solid var(--el-border-color);
	padding-left:10px
}
/* 小屏幕 (平板, 768px 及以上) */
@media (min-width: 768px) {
	:deep(.chat_dialog) {
		width: 100%;
	}
}

/* 中等屏幕 (桌面, 992px 及以上) */
@media (min-width: 992px) {
	:deep(.chat_dialog) {
		width: 100%;
	}
}

:deep(.goods_img .el-image) {
	border-radius: 4px;
	height: 50px;
	width: 50px;
	display: inline-block;
	display: flex;
}

/* 大屏幕 (大桌面, 1200px 及以上) */
@media (min-width: 1600px) {
	:deep(.chat_dialog) {
		width: 68%;
	}
}

/* 超大屏幕 (更大桌面, 1920px 及以上) */
@media (min-width: 1920px) {
	:deep(.chat_dialog) {
		width: 68%;
	}
}

:deep(.textarea_send .el-textarea__inner) {
	resize: none;
	border: 0px solid #DCDFE6;
	box-shadow: 0 0 0 0px var(--el-input-border-color, var(--el-border-color)) inset;
	height: 13vh !important;
	border-radius: 15px 15px 0 0 !important;
	/* 左上、右上、右下、左下 */
}

:deep(.textarea_remark .el-textarea__inner) {

	height: 13vh !important;

}

:deep(.textarea_remark) {

	height: 13vh !important;
}

:deep(.textarea_send .el-textarea__inner:hover) {
	resize: none;
	border: 0px solid #DCDFE6;
	box-shadow: 0 0 0 0px var(--el-input-border-color, var(--el-border-color)) inset;
}
</style>